module.exports = __webpack_public_path__ + "img/7-eleven.8401e6c1.png";